
import React from "react";

export const LoadingPage: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-brand-darker text-white">
      <div className="flex flex-col items-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-brand-red mb-4"></div>
        <h2 className="text-xl font-semibold">Carregando...</h2>
      </div>
    </div>
  );
};
